export default {
  tags: {
    handle: '标签操作',
    closeall: '关闭所有',
    closeother: '关闭其他'
  },
  route: {
    dataScreen: '数据大屏',
    deviceManagement: '设备管理',
    deviceOverview: '设备概述',
    inventoryRecord: '库存记录',
    agentManagement: '代理商管理',
    agentType: '代理商类型',
    agentTypeSet: '代理商类型设置',
    userManagement: '用户管理',
    productSet: '产品设置',
    revenueCenter: '收益中心',
    orderCenter: '订单中心',
    messageCenter: '消息中心',
    profile: '个人中心',
    productCenter:'产品中心',
    commodityCenter: '商品中心',
    launchPoint:'投放管理'
  },
  app: {
    switchlang: '切换语言成功',
    unlock: '解锁'
  },
  login: {
    edenPart1: '爱普兰',
    edenPart2: '净水租赁',
    btn: '登录',
    register: '注册',
    radioEN: '英语',
    radioZH: '中文',
    forgetpwd: '忘记密码',
    remember: '记住我',
    userplaceholder: '请输入用户名',
    pwdplaceholder: '请输入密码',
    forget_email: '请输入邮箱',
    forget_code: '请输入验证码',
    forget_passwrd: '请输入新密码',
    confirm_passwrd: '请输入确认密码',
    forget_btn: '重置',
    forget_back: '返回',
    validfaild: '登录信息不通过!',
    pwdChanged: '密码重置成功！'
  },
  sidebarDropDown: {
    profile: '个人中心',
    lock: '锁定系统',
    logout: '退出登录'
  },
  msg: {
    msg1: '你有一个新订单',
    msg2: '你的提现已经到账',
    msg3: '用户李白的设备激活码已经过期'
  },
  lock: {
    locked: '系统已被锁定！',
    unlock: '系统已解锁成功！'
  }
}
